export default "skymp5-front/22624a6b10b70dd042175d331857244b.gif";